export default "ae894199595cd2c6.svg"